const PerPageDropdown = ({ perPage, handlePerPageChange }) => {
  const options = [10, 15, 30, 40, 50];
  return (
    <span className="dropdown">
      <button
        className="btn btn-primary-600 not-active text-xs sm:text-sm md:text-base dropdown-toggle toggle-icon"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Select items per page"
      >
        {perPage}
      </button>
      <ul className="dropdown-menu w-full sm:w-24 md:w-32 max-h-60 overflow-y-auto">
        {options.map((value) => (
          <li key={value}>
            <button
              className="dropdown-item w-full px-4 py-2 sm:px-8 sm:py-4 md:px-16 md:py-8 text-xs sm:text-sm md:text-base rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
              onClick={() => handlePerPageChange(value)}
            >
              {value}
            </button>
          </li>
        ))}
      </ul>
    </span>
  );
};
export default PerPageDropdown;